import React from 'react';
import { Card } from 'react-bootstrap';

const CardQualidade = ({ codigo, descricao }) => {
  const descricaoExibida = descricao != null && descricao !== '' ? descricao : '-';

  return (
    <Card className="h-100 shadow-sm">
      <Card.Body className="py-2 px-3">
        <strong
          className="d-block text-truncate"
          style={{ fontSize: '0.95rem' }}
          title={descricaoExibida}
        >
          {descricaoExibida}
        </strong>
        <small className="text-muted">{`#${codigo}`}</small>
      </Card.Body>
    </Card>
  );
};

export default CardQualidade;
